/**
 * The array of tenants has a home treecounter with styling that differs from the profile treecounter.
 */
export const _tenants = [
  'nitrosb',
  'energizer',
  'senatDerWirtschaft',
  'pampers',
  'interactClub',
  'culchacandela',
  'xiting',
  'lacoqueta',
  'ulmpflanzt',
  'sitex',
  '3pleset',
  'weareams',
];
